export default __webpack_public_path__ + "static/media/RW-Barein(1140x600).7a4ea60c.webp";